(function () {
  'use strict';

  if (window.providoorCarouselLifecycle) {
    window.providoorCarouselLifecycle.scan(document);
    return;
  }

  const OPTIONS = {
  "how-it-works": {
    "perPage": 1,
    "arrows": true,
    "pagination": true,
    "perMove": 1,
    "type": "loop",
    "autoplay": "play",
    "adaptiveHeight": true,
    "rewind": true,
    "drag": true,
    "interval": 4000,
    "keyboard": true
  },
  "reviews": {
    "perPage": 2,
    "arrows": false,
    "pagination": true,
    "perMove": 1,
    "type": "loop",
    "adaptiveHeight": true,
    "rewind": true,
    "autoplay": "play",
    "drag": true,
    "interval": 4000,
    "keyboard": true,
    "padding": {
      "right": 340
    },
    "breakpoints": {
      "460": {
        "perPage": 1,
        "padding": {
          "right": 70
        }
      },
      "660": {
        "perPage": 1,
        "padding": {
          "right": 130
        }
      },
      "860": {
        "perPage": 1,
        "padding": {
          "right": 230
        }
      },
      "950": {
        "padding": {
          "right": 130
        }
      },
      "1150": {
        "padding": {
          "right": 130
        }
      }
    }
  },
  "chefs": {
    "perPage": 5,
    "arrows": true,
    "pagination": false,
    "perMove": 1,
    "type": "loop",
    "autoplay": "play",
    "adaptiveHeight": true,
    "rewind": true,
    "drag": true,
    "interval": 4000,
    "keyboard": true,
    "padding": {
      "right": 60
    },
    "breakpoints": {
      "600": {
        "perPage": 1,
        "perMove": 1,
        "arrows": false,
        "pagination": false,
        "rewind": false,
        "padding": {
          "right": 120
        }
      },
      "767": {
        "perPage": 2,
        "perMove": 1,
        "arrows": false,
        "pagination": false,
        "rewind": false,
        "padding": {
          "right": 100
        }
      },
      "990": {
        "perPage": 3,
        "padding": {
          "right": 180
        }
      },
      "1240": {
        "perPage": 4,
        "padding": {
          "right": 220
        }
      },
      "1580": {
        "perPage": 5
      },
      "1780": {
        "perPage": 5
      }
    }
  }
};
  const SELECTOR = '[data-providoor-carousel]';
  const controllers = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function inViewport(root) {
    const box = root.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 &&
      box.top < window.innerHeight && box.left < window.innerWidth;
  }

  function managedAutoplay(owner, splide, components, options) {
    let timer = null;
    let startedAt = 0;
    let remaining = options.interval;
    let running = false;
    let destroyed = false;
    let hovered = owner.root.matches(':hover');
    const listeners = [];
    const bind = (element, name, handler) => {
      if (!element) return;
      element.addEventListener(name, handler);
      listeners.push(() => element.removeEventListener(name, handler));
    };
    const interval = () => {
      const slide = components.Slides.getAt(splide.index);
      const value = Number(slide && slide.slide.getAttribute('data-splide-interval'));
      return value > 0 ? value : options.interval;
    };
    const permitted = () => !destroyed && !owner.manualPaused && owner.visible &&
      !owner.editorSelected && !document.hidden && !reducedMotion.matches &&
      !(options.pauseOnHover && hovered) &&
      !(options.pauseOnFocus && owner.root.contains(document.activeElement)) &&
      components.Slides.isEnough();

    function stop() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
        remaining = Math.max(0, remaining - (Date.now() - startedAt));
      }
      if (running) {
        running = false;
        splide.emit('autoplay:pause');
      }
    }

    function sync() {
      if (!permitted()) { stop(); return; }
      if (timer !== null) return;
      if (options.resetProgress || remaining <= 0) remaining = interval();
      startedAt = Date.now();
      timer = setTimeout(() => {
        timer = null;
        remaining = interval();
        if (!permitted()) { stop(); return; }
        splide.emit('autoplay:playing', 1);
        splide.go('>');
        sync();
      }, remaining);
      if (!running) {
        running = true;
        splide.emit('autoplay:play');
      }
    }

    function reset() {
      if (timer !== null) clearTimeout(timer);
      timer = null;
      remaining = interval();
      sync();
    }

    function play() {
      owner.manualPaused = false;
      sync();
    }

    function pause(manual = true) {
      if (manual !== false) owner.manualPaused = true;
      stop();
    }

    return {
      mount() {
        bind(owner.root, 'mouseenter', () => { hovered = true; sync(); });
        bind(owner.root, 'mouseleave', () => { hovered = false; sync(); });
        bind(owner.root, 'focusin', sync);
        bind(owner.root, 'focusout', () => queueMicrotask(sync));
        const elements = components.Elements;
        for (const [key, handler] of [['play', play], ['pause', pause]]) {
          const button = elements[key];
          if (button) {
            button.setAttribute('aria-controls', elements.track.id);
            button.setAttribute('aria-label', options.i18n[key]);
            bind(button, 'click', handler);
          }
        }
        splide.on('move scroll refresh updated', reset);
        sync();
      },
      destroy() {
        destroyed = true;
        stop();
        listeners.forEach((remove) => remove());
      },
      play,
      pause,
      isPaused: () => !running,
      sync
    };
  }

  class Carousel {
    constructor(root) {
      this.root = root;
      this.kind = root.dataset.providoorCarousel;
      this.visible = inViewport(root);
      this.manualPaused = false;
      this.editorSelected = false;
      this.index = 0;
      this.media = this.kind === 'how-it-works' ? window.matchMedia('(max-width: 940px)') : null;
      this.onMedia = () => { this.visible = inViewport(root); this.update(); };
      if (this.media) this.media.addEventListener('change', this.onMedia);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.target === root && entry.isIntersecting && entry.intersectionRatio > 0);
          this.update();
        });
        this.observer.observe(root);
      }
      this.update();
    }

    update() {
      if (this.destroyed || !this.root.isConnected) return;
      if (this.media && !this.media.matches) {
        this.unmount();
        return;
      }
      if (!this.instance && typeof window.Splide === 'function') {
        const settings = Object.assign({}, OPTIONS[this.kind], { start: this.index });
        this.instance = new window.Splide(this.root, settings);
        this.instance.mount({ Autoplay: (splide, components, options) => managedAutoplay(this, splide, components, options) });
      }
      if (this.instance) this.instance.Components.Autoplay.sync();
    }

    unmount() {
      if (!this.instance) return;
      this.index = this.instance.index;
      this.instance.destroy(true);
      this.instance = null;
    }

    destroy() {
      this.destroyed = true;
      this.unmount();
      if (this.observer) this.observer.disconnect();
      if (this.media) this.media.removeEventListener('change', this.onMedia);
    }
  }

  function scan(container) {
    const nodes = Array.from(container.querySelectorAll(SELECTOR));
    if (container.matches && container.matches(SELECTOR)) nodes.unshift(container);
    nodes.forEach((root) => {
      if (OPTIONS[root.dataset.providoorCarousel] && !controllers.has(root)) controllers.set(root, new Carousel(root));
    });
    controllers.forEach((controller, root) => {
      if (!root.isConnected) { controller.destroy(); controllers.delete(root); }
      else controller.update();
    });
  }

  function syncAll() {
    controllers.forEach((controller) => controller.update());
  }

  function editorSelection(event, selected) {
    controllers.forEach((controller, root) => {
      if (event.target === root || event.target.contains(root)) {
        controller.editorSelected = selected;
        controller.update();
      }
    });
  }

  window.providoorCarouselLifecycle = { scan };
  document.addEventListener('visibilitychange', syncAll);
  reducedMotion.addEventListener('change', syncAll);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((controller, root) => {
      if (event.target === root || event.target.contains(root)) { controller.destroy(); controllers.delete(root); }
    });
  });
  document.addEventListener('shopify:section:reorder', () => {
    controllers.forEach((controller) => { controller.visible = inViewport(controller.root); controller.update(); });
  });
  document.addEventListener('shopify:section:select', (event) => editorSelection(event, true));
  document.addEventListener('shopify:section:deselect', (event) => editorSelection(event, false));
  if (!('IntersectionObserver' in window)) {
    let queued = false;
    const measure = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        controllers.forEach((controller) => { controller.visible = inViewport(controller.root); controller.update(); });
      });
    };
    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  window.addEventListener('load', () => scan(document), { once: true });
})();
